/**
 * LiveFlight Results Module
 * Handles flight search results and suggestions
 */

/**
 * Results state properties
 */
export const state = {
  results: [],
  suggestions: [],
  can_search_suggestions: true,
};

/**
 * Custom mutations for results state
 */
export const mutations = {
  // Update dictionaries in results
  dictionaries(state, data) {
    state.results.dictionaries = data;
  },

  // Reset search state (partial - only results-related)
  reset_results(state) {
    state.results = [];
  },
};

/**
 * Keys to persist in local storage
 * Note: Results are not persisted (too large and would be stale)
 */
export const localStorageKeys = [];
